// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3JPTo","inner":"Footer_inner__2J1BB"};